
export default {
  props: {
    label: { type: String, required: true },
    href: { type: String, required: true },
  },
};
